import { useAuthStore } from '@/store/auth-store'
import { PropsWithChildren } from 'react'
import { Navigate } from 'react-router-dom'
import { ROUTES } from '.'

export const AuthGuard = ({ children }: PropsWithChildren) => {
    const { accessToken } = useAuthStore()

    return accessToken ? children : <Navigate to={ROUTES.LOGIN} />
}
